import hexaData from '@/data/Hexastat.json'

export const calculateTotalLevel = (mainStatLevel, additionalStat1Level, additionalStat2Level) => {
  return mainStatLevel + additionalStat1Level + additionalStat2Level
}

export const calculateTotalSoulAlderFragment = (mainStatLevel, additionalStat1Level, additionalStat2Level) => {
  let total = 0
  for (let i = 0; i < mainStatLevel; i++) {
    total += hexaData.successRates[i].soulAlderFragment
  }
  for (let i = 0; i < additionalStat1Level; i++) {
    total += hexaData.successRates[i].soulAlderFragment
  }
  for (let i = 0; i < additionalStat2Level; i++) {
    total += hexaData.successRates[i].soulAlderFragment
  }
  return total
}

export const enhanceStats = (mainStatLevel, additionalStat1Level, additionalStat2Level) => {
  const totalLevel = calculateTotalLevel(mainStatLevel, additionalStat1Level, additionalStat2Level)
  if (totalLevel >= 20) return { mainStatLevel, additionalStat1Level, additionalStat2Level }

  // 根據主要屬性等級獲取機率
  const rates = hexaData.successRates[Math.min(mainStatLevel, 9)]
  
  // 計算每個屬性的權重
  const weights = []
  let totalWeight = 0

  // 修改主屬性的權重計算邏輯
  if (mainStatLevel < 10 && totalLevel < 20) {
    const weight = rates.mainStat
    weights.push({ type: 'main', weight, level: mainStatLevel })
    totalWeight += weight
  }

  if (additionalStat1Level < 10 && totalLevel < 20) {
    const weight = rates.additionalStat1
    weights.push({ type: 'additional1', weight, level: additionalStat1Level })
    totalWeight += weight
  }

  if (additionalStat2Level < 10 && totalLevel < 20) {
    const weight = rates.additionalStat2
    weights.push({ type: 'additional2', weight, level: additionalStat2Level })
    totalWeight += weight
  }

  // 如果沒有可強化的屬性，直接返回
  if (weights.length === 0) {
    return { mainStatLevel, additionalStat1Level, additionalStat2Level }
  }

  // 生成隨機值
  const random = Math.random() * totalWeight

  // 根據權重決定強化哪個屬性
  let currentWeight = 0
  for (const { type, weight, level } of weights) {
    currentWeight += weight
    if (random <= currentWeight) {
      switch (type) {
        case 'main':
          mainStatLevel++
          break
        case 'additional1':
          additionalStat1Level++
          break
        case 'additional2':
          additionalStat2Level++
          break
      }
      break
    }
  }

  return { mainStatLevel, additionalStat1Level, additionalStat2Level }
} 